








/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { namespace } from 'vuex-class'
import { ClientPolicyDto } from '../../api'

const clientPolicyStore = namespace('ClientPolicyStore')

@Component({
  components: {
    AppForm
  }
})
export default class CommissionPaidDetailsTab extends Vue {
  @clientPolicyStore.State
  private policy: ClientPolicyDto

  @clientPolicyStore.State
  private productMetadata: any

  get isDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get giOthersFormStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Commission Rate (%)',
        model: {
          get: () => this.productMetadata.commissionRate,
          set: (val) => {
            this.productMetadata.commissionRate = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Commission Payment',
        options: [
          { value: '', label: '' },
          { value: 100, label: 'Flat amount' },
          { value: 80, label: '80% of net commission' },
          { value: 75, label: '75% of net commission' },
          { value: 70, label: '70% of net commission' },
          { value: 60, label: '60% of net commission' },
          { value: 50, label: '50% of net commission' }
        ],
        model: {
          get: () => this.productMetadata.commissionPayment,
          set: (val) => {
            this.productMetadata.commissionPayment = val
            this.productMetadata.commissionPayable = this.calculateCommissionPayable()
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Gross Commission Earned ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.grossCommissionEarned,
          set: (val) => {
            this.productMetadata.grossCommissionEarned = val
            this.productMetadata.commissionPayable = this.calculateCommissionPayable()
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Commission Payable ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.productMetadata.commissionPayable,
          set: (val) => {
            this.productMetadata.commissionPayable = val
          }
        },
        disabled: true
      }
    ]
  }

  calculateCommissionPayable () {
    return this.productMetadata.grossCommissionEarned * this.productMetadata.commissionPayment / 100
  }

  get formStructure (): FormStructure<ClientPolicyDto> {
    return this.giOthersFormStructure
  }
}
